/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const HeartFilled: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="heart-filled" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M235.3761066666667 1052.2446933333333C347.9278933333334 1167.0024 530.5296533333334 1167.0332266666667 643.1195200000001 1052.3371733333333L679.9737066666668 1015.29168L716.8278933333333 1052.3371733333333C829.41776 1167.0332266666667 1012.0213333333334 1167.0024 1124.5749333333333 1052.2446933333333C1236.9562666666666 937.6556266666666 1236.9562666666666 752.0265066666666 1124.5749333333333 637.43744L1124.0309333333332 636.8870933333333L679.9737066666668 221.5984000000001L235.9155733333334 636.8870933333333L235.3761066666667 637.43744C122.9884266666667 752.0265066666666 122.9884266666667 937.6556266666666 235.3761066666667 1052.2446933333333z" : "M188.3008853333333 841.7957546666667C278.3423146666667 933.60192 424.4237226666666 933.6265813333334 514.495616 841.8697386666666L543.9789653333333 812.233344L573.4623146666667 841.8697386666666C663.534208 933.6265813333334 809.6170666666667 933.60192 899.6599466666667 841.7957546666667C989.5650133333332 750.1245013333332 989.5650133333332 601.6212053333334 899.6599466666667 509.9499520000001L899.2247466666666 509.5096746666667L543.9789653333333 177.27872L188.7324586666667 509.5096746666667L188.3008853333333 509.9499520000001C98.3907413333333 601.6212053333334 98.3907413333333 750.1245013333332 188.3008853333333 841.7957546666667z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
HeartFilled.displayName = `Blueprint5.Icon.HeartFilled`;
export default HeartFilled;
